import React, { createContext, useContext } from "react";

const NonceContext = createContext<string | undefined>(undefined);

export const NonceProvider: React.FC<React.PropsWithChildren<{ nonce?: string }>> = ({
  nonce,
  children,
}) => (
  <NonceContext.Provider value={nonce}>
    {children}
  </NonceContext.Provider>
);

export const useNonce = () => useContext(NonceContext);
